/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Dropdown, theme } from "@nordcloud/gnui";
import { FilterHeader } from "~/components";
import { Mode, Options } from "./types";
import { getSelectedMode } from "./utils";

type Props = {
  allowModeChange?: boolean;
  isExcludeSelected?: boolean;
  name?: string;
  options: Options[];
  selectedOption?: string;
  onModeChange?: (mode: Mode) => void;
  onSelect: (value: string) => void;
  onClear: () => void;
};

export function SelectableDropdown({
  allowModeChange,
  isExcludeSelected,
  name,
  options,
  selectedOption,
  onModeChange,
  onSelect,
  onClear,
}: Props) {
  return (
    <div>
      <FilterHeader
        allowModeChange={allowModeChange}
        defaultMode={getSelectedMode(isExcludeSelected)}
        onModeChange={onModeChange}
      />
      <div style={{ padding: theme.spacing.spacing02 }}>
        <Dropdown
          name={name ?? "Select"}
          value={selectedOption}
          options={options}
          onChange={(selected) => {
            onSelect?.(selected);
          }}
          onClear={() => {
            onClear();
          }}
          minNumOfOptionsToShowSearchBox={5}
        />
      </div>
    </div>
  );
}
